import { create } from "zustand";

const MAX_VISIBLE = 5;

export interface Toast {
  id: string;
  type: "error" | "success" | "info";
  message: string;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, "id">) => void;
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  addToast: (toast) =>
    set((state) => {
      const next = [
        ...state.toasts,
        { ...toast, id: crypto.randomUUID() },
      ];
      // Keep only the most recent MAX_VISIBLE toasts
      return { toasts: next.slice(-MAX_VISIBLE) };
    }),

  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));
